export default {
  fieldNames: {
    category: 'Category',
    stockType: 'Stock type',
    sosUser: 'SOS user',
    sosDate: 'SOS date',
    minimumStock: 'Minimum SOS stock',
    maximumStock: 'Maximum SOS stock',
    criticalitySOS: 'SOS criticality',
    availability: 'Availability',
    annualConsumption: 'Annual consumption',
    expenseItem: 'Expense item',
    dangerIndex: 'Danger index',
    responsibleArea: 'Responsible area',
    warehouse: 'Warehouse',
    criticality: 'Criticality',
    stockQualifier: 'Stock Qualifiers',
    stockQualifierSelected: 'Selected Stock Qualifiers',
  },
};



// WEBPACK FOOTER //
// ./src/i18n/en-us/cataloger/createNewMaterials/Stages/inventory.js